import React from "react"
import { Input } from "antd"

const renderTextfield = props => (
  <Input size="large" placeholder="large size" {...props} {...props.input} />
)

renderTextfield.propTypes = {}

export default renderTextfield



// WEBPACK FOOTER //
// ./src/components/render-textfield/render-textfield.component.js